module.exports = __webpack_public_path__ + "assets/img/eeb2-um.svg";